import { Actions } from 'vuex-smart-module';
import { AxiosResponse } from 'axios';
import { ResponseStatuses } from '@/enums';
import { Filters, FiltersPagination } from '@/types';
import { SubpartnersService } from '../services';
import { Subpartners } from '../types';
import SubpartnersGetters from './getters';
import SubpartnersMutations from './mutations';
import SubpartnersState from './state';

const subpartnersService = new SubpartnersService();

export default class SubpartnersActions extends Actions<
  SubpartnersState,
  SubpartnersGetters,
  SubpartnersMutations,
  // eslint-disable-next-line no-use-before-define
  SubpartnersActions
> {
  async get_subpartners(storage_limit?: number) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit: storage_limit ?? itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_SUBPARTNERS_LOADING(true);

      const { data, meta } = await subpartnersService.get_subpartners(payload);

      this.mutations.SET_SUBPARTNERS(data.items);
      this.mutations.SET_REGIONS(data.regions);
      this.mutations.SET_CITIES(data.cities);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_SUBPARTNERS_LOADING(false);
    }
  }

  async get_subpartner_by_id(id: string | number) {
    try {
      const { data } = await subpartnersService.get_subpartner_by_id(id);

      this.mutations.SET_CURRENT_SUBPARTNER(data);
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async update_subpartner(subpartner: Subpartners.Subpartner) {
    try {
      const { code = ResponseStatuses.Success.UPDATED } = await subpartnersService.update_subpartner(subpartner);

      this.mutations.SET_CURRENT_SUBPARTNER(subpartner);

      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }
}
